@if (title) {
<div class="-contact-block-row">
  <div class="-contact-block-content">
    <h3>{{ title }}</h3>
    @if (description) {
    <p [innerHTML]="description"></p>
    } @if (links.length > 0) {
    <div class="-links">
      @for (item of links; track item) {
      <app-link [to]="item.path">{{ item.title }}</app-link>
      }
    </div>
    }
  </div>
</div>
}
